/**
 * EHR Constants
 *
 * Centralized list of all supported EHR systems with display metadata.
 * The `key` field must match the strings returned by the API in `valid_ehrs`
 * and used as keys in `ehrConfig`.
 *
 * @module EhrConstants
 */

export const ALL_EHRS = [
  { key: "athena", displayName: " ", logo: "/icons/ehrs/athena.png", magnifyby: 45 ,type: "medical" },
  { key: "epic", displayName: "", logo: "/icons/ehrs/Epic.png", magnifyby: 15 ,type: "medical" },
  { key: "modmed", displayName: " ", logo: "/icons/ehrs/ModMed.png", magnifyby: 26 ,type: "medical" },
  { key: "greenway", displayName: " ", logo: "/icons/ehrs/Greenway.png", magnifyby: 26 ,type: "medical" },
  { key: "veradigmpm", displayName: " PM ", logo: "/icons/ehrs/Veradigm.png", magnifyby: 36 ,type: "medical" },
  { key: "veradigmehr", displayName: " EHR ", logo: "/icons/ehrs/Veradigm.png", magnifyby: 36 ,type: "medical" },
  { key: "opendental", displayName: " ", logo: "/icons/ehrs/Opendental.png", magnifyby: 26 ,type: "dental" },
  { key: "denticon", displayName: " ", logo: "/icons/ehrs/Denticon.png", magnifyby: 26 ,type: "dental" },
  { key: "cloud9", displayName: " ", logo: "/icons/ehrs/Cloud9.png", magnifyby: 26 ,type: "dental" },
  { key: "dentrixascend", displayName: " ", logo: "/icons/ehrs/dentrixascend.png", magnifyby: 10, type: "dental" },
  { key: "carestack", displayName: " ", logo: "/icons/ehrs/Carestack.png", magnifyby: 26 ,type: "dental" },
  { key: "nextgen", displayName: " ", logo: "/icons/ehrs/nextgen.png", magnifyby: 26 ,type: "dental" },
  // { key: "oryx", displayName: " ", logo: "/icons/ehrs/oryx.png" },
];

const FALLBACK_EHR = { key: "", displayName: "", logo: "/icons/ehrs/Carestack.png", magnifyby: 26 };

/**
 * Resolves EHR metadata by key (case-insensitive). Handles API variations like Carestack/CareStack, Modmed/ModMed.
 * @param {string} key - EHR key from ehrMappings or API
 * @returns {Object} EHR object with key, displayName, logo, magnifyby
 */
export const getEhrFromKey = (key) => {
  if (!key) return FALLBACK_EHR;
  const found = ALL_EHRS.find((e) => e.key.toLowerCase() === String(key).toLowerCase());
  return found || { ...FALLBACK_EHR, key: key, displayName: key };
};
